module.exports = __webpack_public_path__ + "eb0eca00e5460cd16b764dc13a672bc4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/stock.png
// module id = ./assets/thumbnails/stock.png
// module chunks = 2